import * as React from 'react';
import LrDialog from 'components/LrDialog';
import { GLRatingRequest } from '../../../types/generalLiability.type';
import LumenLoader from '../../Loader';
import { getRaaSHTML, getRaaSJSON } from '../../../services/generalLiabilty';
import GLPropertyTableRowModel from './GLPropertyTable/GLPropertyTableRowModel';
import { Spacing } from '../../Layout';
import { List, ListItem, ListItemText, Typography } from '@mui/material';

interface Props {
    raasPayload: GLRatingRequest;
    rowData?: GLPropertyTableRowModel;
    closeDialogCallback: () => void;
}

const ShowHTMLTableDialog: React.FunctionComponent<Props> = (props) => {
    const { raasPayload, rowData, closeDialogCallback } = props;

    // Local State
    const [raasHTML, setRaaSHTML] = React.useState<string>();

    const fetchRaaSHTML = async () => {
        const html = await getRaaSHTML(raasPayload);
        setRaaSHTML(html);
    };

    React.useEffect(() => {
        fetchRaaSHTML();
    }, []);

    return (
        <LrDialog
            isOpen
            title={`GL Rating Worksheet`}
            maxWidth="lg"
            fullWidth
            closeButton
            onCancel={closeDialogCallback}
        >
            <>
                {!raasHTML && <LumenLoader />}
                {!!raasHTML && (
                    <>
                        <div dangerouslySetInnerHTML={{ __html: raasHTML }} />
                        <Spacing height={'24px'} />
                        <Typography variant={'h4'}>Forms</Typography>
                        <List dense>
                            {!!rowData?.formsList &&
                                rowData.formsList.map((f) => (
                                    <ListItem>
                                        <ListItemText>{f}</ListItemText>
                                    </ListItem>
                                ))}
                        </List>
                    </>
                )}
            </>
        </LrDialog>
    );
};

export default ShowHTMLTableDialog;
